const prefix = ''

export const usersUrls = {
  'user.list': `${prefix}/users`,
  'user.view': (userId = ':userId') => `${prefix}/users/${userId}`,
}
